import { Card, CardContent } from '@/components/ui/card'
import { IconCurrencyPound } from '@tabler/icons-react'
import CTAButton from '@/components/shared/CTAButton'

export function ReferralProcessSection({ className = '' }) {
  return (
    <section className={`w-full pt-7 ${className}`}>
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-foreground mb-4 text-center text-4xl font-black sm:mb-6 sm:text-5xl">
          HOW IT WORKS
        </h2>

        <p className="text-foreground mb-8 text-center text-lg sm:mb-12">
          It&apos;s an easy{' '}
          <strong className="font-raleway-numbers">3 steps</strong> process!
          Refer someone and get your{' '}
          <strong className="font-raleway-numbers">£10 reward</strong>
        </p>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:gap-6">
          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="p-4 text-center lg:p-6">
              <div className="mb-4 flex justify-center">
                <img
                  src="/Icon/share 2.png"
                  alt="Share icon"
                  width="48"
                  height="48"
                  loading="lazy"
                />
              </div>
              <h3 className="text-foreground mb-4 text-lg font-bold">
                <strong>Step 1:</strong>
                <br />
                You share with your friends
              </h3>
              <p className="text-foreground text-sm leading-relaxed">
                Use your personalised QR code to tell your friends about Your
                Claim Matters via Email, X, Facebook, LinkedIn or other social
                media platforms.
              </p>
            </CardContent>
          </Card>

          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="p-4 text-center lg:p-6">
              <div className="mb-4 flex justify-center">
                <img
                  src="/Icon/Submit claim.png"
                  alt="Submit claim icon"
                  width="48"
                  height="48"
                  loading="lazy"
                />
              </div>
              <h3 className="text-foreground mb-4 text-lg font-bold">
                <strong>Step 2:</strong>
                <br />
                Your friends submit a claim
              </h3>
              <p className="text-foreground text-sm leading-relaxed">
                We&apos;ll notify you when one of your friends files a claim.
              </p>
            </CardContent>
          </Card>

          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="p-4 text-center lg:p-6">
              <div className="mb-4 flex justify-center">
                <IconCurrencyPound size={48} className="text-orange-400" />
              </div>
              <h3 className="text-foreground mb-4 text-lg font-bold">
                <strong>Step 3:</strong>
                <br />
                You get money
              </h3>
              <p className="text-foreground text-sm leading-relaxed">
                For every claim that&apos;s successful, we&apos;ll email you a{' '}
                <strong className="font-raleway-numbers">£10 gift card</strong>,
                which you can redeem for any online purchase.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-8 mb-8 text-center">
          <CTAButton text="SHARE YOUR CODE NOW" disabled={true} />
        </div>
      </div>
    </section>
  )
}

export default ReferralProcessSection
